import {MAX_BOT_URL, TELEGRAM_BOT_USERNAME} from '../config/env';

const YM_COUNTER_IDS = [109206504];

export function getYandexClientId() {
    if (typeof ym !== 'function') return Promise.resolve(null);
    const promises = YM_COUNTER_IDS.map(id => new Promise((resolve, reject) => {
        ym(id, 'getClientID', (clientId) => {
            clientId ? resolve(clientId) : reject();
        });
    }));
    // Promise.any polyfill for older browsers (iOS Safari < 14.5)
    return Promise.all(promises.map(p => p.then(val => Promise.reject(val), () => Promise.resolve())))
        .then(() => null, firstResolved => firstResolved);
}

export function getTelegramDeeplink(yandexClientId) {
    if (!yandexClientId) return `tg://resolve?domain=${TELEGRAM_BOT_USERNAME}`;
    return `tg://resolve?domain=${TELEGRAM_BOT_USERNAME}&start=${yandexClientId}`;
}

export function getMaxDeeplink(yandexClientId) {
    if (!yandexClientId) return MAX_BOT_URL;
    return `${MAX_BOT_URL}?start=${yandexClientId}`;
}
